module.exports = __webpack_public_path__ + "static/media/back.89a72c26.svg";